import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import ReportProblemOutlined from "@mui/icons-material/ReportProblemOutlined";
import useQueryJobById from "./useQueryJobById.js";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useTranslationCandidates from "../useTranslationCandidates.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import EmployerItem from "./EmployerItem.js";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DisplayDate from "../../common/widgets/DisplayDate.js";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import BusinessIcon from "@mui/icons-material/Business";
import DisplayApplicationStatus from "./DisplayApplicationStatus.js";
import "./ApplicationListItem.scss";
import DisplayApplicationStatusEffectiveDate from "./DisplayApplicationStatusEffectiveDate.js";
import ApplicationStatusEnum from "../ApplicationStatusEnum.js";

export default function ApplicationListItem(props) {
  const { application } = props;

  const { data: job, loading, errors } = useQueryJobById(application.jobId);
  const { t, loading: tLoading } = useTranslationCandidates();
  useShowLoader(tLoading, "ApplicationListItem");

  return (
    <div className="ApplicationListItem">
      <HorizontalLoader>
        <WaitForData
          loading={loading}
          errors={errors}
          onError={() => <ReportProblemOutlined className="LoadingError" />}
          onLoaded={() => (
            <Row className="ApplicationListItem">
              <Col className="job-title-col">{job ? job.title : t("candidates:candidates_job_details_unavailable_job")}</Col>
              <Col className="employer-item-col">
                <Row>
                  <Col className="icon-col">
                    <BusinessIcon />
                  </Col>
                  <Col className="icon-title">
                    {job && <EmployerItem organizationId={job.organizationId} />}
                  </Col>
                </Row>
              </Col>
              <Col className="commission-col">
                <Row>
                  <Col className="icon-col">
                    <MonetizationOnIcon />
                  </Col>
                  <Col className="icon-title">
                    {job &&
                      t("candidates:candidates_job_details_commission_amounts", {
                        amount: job.commission,
                      })
                    }
                  </Col>
                </Row>
              </Col>
              <Col className="status-col">
                <Row>
                  <Col>
                    <DisplayApplicationStatus application={application} job={job}/>
                  </Col>
                </Row>
                {(application.status === ApplicationStatusEnum.HIRED || application.status === ApplicationStatusEnum.HIRING_CANCELLED) &&
                  <Row>
                    <Col>
                      <HorizontalLoader>
                        <DisplayApplicationStatusEffectiveDate applicationId={application._id}/>
                      </HorizontalLoader>
                    </Col>
                  </Row>
                }
              </Col>

              <Col className="date-col">
                <Row>
                  <Col className="icon-col">
                    <DateRangeIcon />
                  </Col>
                  <Col className="icon-title">
                    <DisplayDate date={application.createdAt} />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        />
      </HorizontalLoader>
    </div>
  );
}
